import { useLayoutEffect, useMemo, useState } from "react";

const breakPointsVariables = {
  sm: "--breakpoint-sm",
  md: "--breakpoint-md",
  lg: "--breakpoint-lg",
  xl: "--breakpoint-xl",
  "2xl": "--breakpoint-2xl",
};

export default function useTwBreakpoint(
  breakpoint: keyof typeof breakPointsVariables,
) {
  const mediaQuery = useMemo(
    () =>
      `(min-width: ${getComputedStyle(document.documentElement).getPropertyValue(breakPointsVariables[breakpoint])})`,
    [],
  );

  const [isMatchingQuery, setIsMatchingQuery] = useState<boolean>(
    window.matchMedia(mediaQuery).matches,
  );

  useLayoutEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQuery);
    const documentChangeHandler = () =>
      setIsMatchingQuery(mediaQueryList.matches);

    mediaQueryList.addEventListener("change", documentChangeHandler);

    setIsMatchingQuery(mediaQueryList.matches);

    return () => {
      mediaQueryList.removeEventListener("change", documentChangeHandler);
    };
  }, [mediaQuery]);

  return isMatchingQuery;
}
